import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { UnitsService } from '../../services/units.service';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';
import { AcercadeComponent } from 'src/app/components/shared/components/acercade/acercade.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {
  getPermissions,
  getSeeLicenses,
  getSeeSkuld,
  getAnaUnit,
  getSeeAna,
  getUserUnits,
  getSklud,
  getSeeUsers,
  getSeeRoles,
  getImmersionPermission,
  getForskerPermission,
  getSeeLogSistemControl,
  getSeeLogCases,
  getSeeMainReports,
  getSeeStatusConection,
  getSeeUnits,
  getSeeTimer,
} from './utils';
import { getNavRoutes } from './sidebarRoutes';

@Component({
  selector: `app-main-layout-sidebar`,
  templateUrl: `main-layout-sidebar.component.html`,
  styleUrls: [`main-layout-sidebar.component.scss`],
})
export class MainLayoutSidebarComponent implements OnInit {
  skuld: boolean = false;
  units!: IUnit[];
  view: boolean;
  hasUnits: boolean = true;
  nav = getNavRoutes(this);

  constructor(
    public userService: UserService,
    private unitsService: UnitsService,
    private router: Router,
    private dialog: MatDialog,
    private elementRef: ElementRef
  ) {
    if (this.unistAvailable.length == 0) this.hasUnits = false;
    if (this.userService.currentUser.role.skuld) {
      this.nav[0].link = '/dashboard-alerts';
      this.skuld = true;
    }
  }

  ngOnInit(): void {}

  toggleSidebar() {
    this.view = !this.view;
  }

  /** Abierto, un clic fuera del menú lo cierra (como en OSINT). */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.view) return;
    if (!this.elementRef.nativeElement.contains(event.target)) this.view = false;
  }
  selectedOption(name) {
    let found = false;

    this.nav.forEach((element) => {
      if (element.name == name && name != 'Acerca De') {
        element.active = true;
        found = true;

        if (element.link) {
          this.router.navigate([element.link]);
        }
      } else if (element.subNav) {
        element.subNav.forEach((subElement) => {
          if (subElement.name == name) {
            subElement.active = true;
            if (subElement.link) {
              this.router.navigate([subElement.link]);
            }
          } else {
            subElement.active = false;
          }
        });
      } else if (element.name == 'Acerca De' && name == 'Acerca De') {
        this.openAcercaDe();
        element.active = false;
      }
      if (element.name != name && name != 'Acerca De') {
        element.active = false;
      }
    });
  }
  getUnits() {
    this.unitsService.getAll().subscribe({
      next: (res: IUnit[]) => {
        this.units = res;
      },
    });
  }

  get unistAvailable() {
    return this.userService.currentUser?.role.units;
  }

  get permissions() {
    return getPermissions(this.userService);
  }

  get seeLicenses() {
    return getSeeLicenses(this.permissions);
  }

  get seeSkuld() {
    return getSeeSkuld(this.permissions, this.userService);
  }

  get anaUnit() {
    return getAnaUnit(this.userService);
  }

  get seeAna() {
    return getSeeAna(this.userService);
  }

  get userUnits() {
    return getUserUnits(this.userService);
  }

  get sklud() {
    return getSklud(this.userService);
  }

  get seeUsers() {
    return getSeeUsers(this.permissions);
  }

  get seeRoles() {
    return getSeeRoles(this.permissions);
  }

  get immersionPermission() {
    return getImmersionPermission(this.permissions);
  }

  get forskerPermission() {
    return getForskerPermission(this.permissions);
  }

  get seeLogSistemControl() {
    return getSeeLogSistemControl(this.permissions);
  }

  get seeLogCases() {
    return getSeeLogCases(this.permissions);
  }

  get seeMainReports() {
    return getSeeMainReports(this.permissions);
  }

  get seeStatusConection() {
    return getSeeStatusConection(this.permissions);
  }

  get seeUnits() {
    return getSeeUnits(this.permissions);
  }

  get seeTimer() {
    return getSeeTimer(this.permissions);
  }

  openAcercaDe() {
    this.dialog.open(AcercadeComponent);
  }

  clickNav(option: any) {
    // Colapsado (70 px) las sub-entradas no caben: un grupo abre el menú ya
    // desplegado; un enlace navega y lo cierra.
    const abrir = !this.view && !!option.subNav;
    if (option.view !== null || option.view !== undefined)
      option.view = abrir || !option.view;
    let optionsArr = option.click.split('/');
    this.view = !!option.subNav;
    this[optionsArr[0]](optionsArr[1]);
  }
}
